/**
 * Attribution — UTM-/Klick-Parameter (Google Ads, Meta) erfassen und für den Kauf bereitstellen.
 * First-Touch (erste Kampagne) + Last-Touch (letzte Kampagne vor Kauf) in localStorage.
 */
const KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid', 'msclkid'];
const FIRST_KEY = 'fuelx_attr_first';
const LAST_KEY = 'fuelx_attr_last';

export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const touch = {};
    KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) touch[k] = v.slice(0, 300);
    });
    if (Object.keys(touch).length === 0) return;
    touch.landing_page = window.location.pathname.slice(0, 300);
    if (document.referrer) touch.referrer = document.referrer.slice(0, 300);
    touch.captured_at = new Date().toISOString();
    localStorage.setItem(LAST_KEY, JSON.stringify(touch));
    if (!localStorage.getItem(FIRST_KEY)) localStorage.setItem(FIRST_KEY, JSON.stringify(touch));
  } catch {
    /* Storage blockiert — Attribution ist optional */
  }
}

export function getAttribution() {
  try {
    const first = JSON.parse(localStorage.getItem(FIRST_KEY) || 'null');
    const last = JSON.parse(localStorage.getItem(LAST_KEY) || 'null');
    if (!first && !last) return undefined;
    return { first_touch: first || undefined, last_touch: last || undefined };
  } catch {
    return undefined;
  }
}
